import { render, staticRenderFns } from "./FinesPage.vue?vue&type=template&id=46491cb3&scoped=true"
import script from "./FinesPage.vue?vue&type=script&lang=js"
export * from "./FinesPage.vue?vue&type=script&lang=js"
import style0 from "./FinesPage.vue?vue&type=style&index=0&id=46491cb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46491cb3",
  null
  
)

export default component.exports